<script>
import { BFormGroup } from 'bootstrap-vue'
import vSelect from 'vue-select'
import ListOfObjects from "@/views/product/components/product-card/composition/components/ListOfObjects.vue";

export default {
    components: { BFormGroup, vSelect, ListOfObjects },
    props: {
        readOnly: {
            type: Boolean,
            default: false,
        },
        value: {},
        config: {
            type: Object,
            default() {
                return {
                    data: [],
                    properties: {},
                };
            }
        }
    },
    data() {
        return {
            componentValue: this.value,
        };
    },
    watch: {
        value(newValue) {
            this.componentValue = newValue;
        }
    },
    computed: {
        propsConfig() {
            return this.config && this.config.properties ? this.config.properties : {};
        },
        label() {
            if (this.propsConfig.label) {
                return this.$t(this.propsConfig.label);
            }
            return this.config.type || '';
        },
        placeholder() {
            return this.propsConfig.placeholder ? this.$t(this.propsConfig.placeholder) : '';
        },
        options() {
            return Array.isArray(this.config.data) ? this.config.data : [];
        },
        optionLabel() {
            return this.propsConfig.optionLabel || 'title';
        },
        optionValue() {
            return this.propsConfig.optionValue || undefined;
        },
        multiple() {
            return this.propsConfig.multiple !== undefined ? this.propsConfig.multiple : true;
        },
        required() {
            return this.propsConfig.required === true;
        },
        clearable() {
            return this.propsConfig.clearable !== undefined ? this.propsConfig.clearable : true;
        },
        searchable() {
            return this.propsConfig.searchable !== undefined ? this.propsConfig.searchable : true;
        },
        noOptionsText() {
            return this.propsConfig.noOptionsText ? this.$t(this.propsConfig.noOptionsText) : '';
        },
        hasValue() {
            if (Array.isArray(this.normalizedValue)) {
                return this.normalizedValue.length > 0;
            }
            return !!this.normalizedValue;
        },
        mandatoryClass() {
            return this.required && !this.hasValue ? 'input-bg-warning' : '';
        },
        normalizedValue() {
            return this.componentValue;
        },
        readOnlyElements() {
            if (!Array.isArray(this.normalizedValue)) {
                return [];
            }

            return this.normalizedValue
                .map((item) => this.resolveItemToOption(item))
                .filter((item) => item !== null);
        },
        readOnlySingleValue() {
            if (!this.hasValue || Array.isArray(this.normalizedValue)) {
                return null;
            }

            const resolved = this.resolveItemToOption(this.normalizedValue);
            if (resolved === null) {
                return this.normalizedValue;
            }

            return resolved[this.optionLabel] || resolved;
        }
    },
    methods: {
        resolveItemToOption(item) {
            if (item && typeof item === 'object') {
                return item;
            }

            if (!this.optionValue) {
                return null;
            }

            return this.options.find((option) => option[this.optionValue] === item) || null;
        },
        onInput(value) {
            this.$emit('input', value);
        }
    }
}
</script>

<template>
    <div>
        <div v-if="readOnly">
            <h5>{{ label }}</h5>
            <div v-if="!hasValue">-</div>
            <ListOfObjects v-else-if="Array.isArray(normalizedValue)" :elements="readOnlyElements" />
            <div v-else>{{ readOnlySingleValue }}</div>
        </div>
        <b-form-group
            v-else
            :label="label"
        >
            <v-select
                v-model="componentValue"
                :class="mandatoryClass"
                :options="options"
                :label="optionLabel"
                :reduce="optionValue ? (option) => option[optionValue] : null"
                :multiple="multiple"
                :clearable="clearable"
                :searchable="searchable"
                :placeholder="placeholder"
                :disabled="readOnly"
                @input="onInput"
            >
                <template v-if="noOptionsText" #no-options>
                    {{ noOptionsText }}
                </template>
            </v-select>
        </b-form-group>
    </div>
</template>
